
import React, {useContext, useState} from "react";
import {FormContext} from "core/FormProvider";
import { Button } from "@material-ui/core";
import {Drawer} from "ui/Drawer";
import TariffServiceForm from "./FormService";
import {AsyncSelectManyButtonWidget} from "form/SelectManyButtonWidget";


export default function TariffServicesForm() {
  const formContext = useContext(FormContext);
  const [open, setOpen] = useState(false);
  const { services } = formContext.item;
  const selectedServices = services.map(tariffService => tariffService.service.id);

  const addTariffService = function (service) {
    formContext.pushArrayValue(
      'services', {
        service: service,
        cost: 0,
      }
    )
  }

  return (
    <>
      <h3 className={'mt-0'}>Общие услуги тарифа</h3>

      <Button
        onClick={() => setOpen(true)}
        variant={'outlined'}
      >
        Выбрать общие услуги
      </Button>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        width={'550px'}
      >
        <h2>Общие услуги тарифа</h2>

        <h3>Выберите услуги</h3>

        <AsyncSelectManyButtonWidget
          value={selectedServices}
          url={'catalog/service'}
          filter={{
            type: 'TARIFF'
          }}
          optionValue={'id'}
          onOptionAdd={(option) => addTariffService(option)}
        />

      </Drawer>

      {services.length > 0 && (
        <div className={'mt-20'}>
          {services.map((tariffService, index) =>
            <TariffServiceForm
              key={index}
              index={index}
              fieldPath={'services'}
              tariffService={tariffService}
            />
          )}
        </div>
      )}
    </>
  )
}